import React from "react";
import { Text, View } from "react-native";
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      name: "",
      message: ""
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      name: error.name,
      message: error.message
    };
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          paddingVertical: 5,
          paddingHorizontal: 10,
          borderWidth: 1,
          borderColor: "#DF1924",
          backgroundColor: "#FCD5D4"
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: {
          color: "#DF1924"
        }
      }, "Something went wrong rendering", " ", /*#__PURE__*/React.createElement(Text, {
        style: {
          fontWeight: "bold"
        }
      }, this.props.type)), /*#__PURE__*/React.createElement(View, {
        style: {
          marginVertical: 5,
          paddingVertical: 5,
          paddingHorizontal: 10,
          borderWidth: 1,
          borderColor: "#DF1924",
          backgroundColor: "#fff"
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: {
          fontSize: 14,
          color: "#000"
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: {
          fontWeight: "bold"
        }
      }, this.state.name, ":"), " ", this.state.message)));
    }
    return this.props.children;
  }
}
//# sourceMappingURL=ErrorBoundary.component.js.map